import { A as r, b as p, n as s, t as d } from "./element-CV9utnHJ.js";
import { P as k } from "./input-element-BGNbdzy2.js";
import { e as f, n as b } from "./ref-Dma3n3i8.js";
import { e as u } from "./class-map-3ADKve8g.js";
var g = Object.defineProperty, m = Object.getOwnPropertyDescriptor, i = (t, a, n, l) => {
  for (var h = l > 1 ? void 0 : l ? m(a, n) : a, c = t.length - 1, o; c >= 0; c--)
    (o = t[c]) && (h = (l ? o(a, n, h) : o(h)) || h);
  return l && h && g(a, n, h), h;
};
let e = class extends k {
  constructor() {
    super(...arguments), this.inputRef = f(), this.value = "", this.checkHelptext = null, this.defaultChecked = !1, this.hasTile = !1, this.isSwitch = !1, this.labelPosition = "right", this.hideLabel = !1, this.checked = null, this.indeterminate = !1, this.type = "checkbox", this.tagText = null, this.optionalTag = !1, this.optionalText = "Valgfritt", this.requiredTag = !1, this.requiredText = "Må fylles ut";
  }
  connectedCallback() {
    super.connectedCallback();
  }
  attributeChangedCallback(t, a, n) {
    t === "defaultChecked" && !this.checked && (this.checked = this.defaultChecked), t === "checked" && (this.checked = this.checked === "" || this.checked === "true" || this.checked === !0, this.inputRef.value && (this.inputRef.value.checked = this.checked)), t === "indeterminate" && (this.indeterminate = this.indeterminate === "" || this.indeterminate === "true" || this.indeterminate === !0, this.inputRef.value && (this.inputRef.value.indeterminate = this.indeterminate)), super.attributeChangedCallback(t, a, n);
  }
  firstUpdated(t) {
    t.has("defaultChecked") && !this.checked && (this.checked = this.defaultChecked), this.inputRef.value && (this.inputRef.value.indeterminate = this.indeterminate === "" || this.indeterminate === "true" || this.indeterminate === !0), super.firstUpdated(t);
  }
  updated(t) {
    t.has("defaultChecked") && !this.checked && (this.checked = this.defaultChecked), t.has("checked") && this.inputRef.value && (this.inputRef.value.checked = this.checked === "" || this.checked === "true" || this.checked === !0), t.has("indeterminate") && this.inputRef.value && (this.inputRef.value.indeterminate = this.indeterminate === "" || this.indeterminate === "true" || this.indeterminate === !0), super.updated(t);
  }
  render() {
    const t = u({
      "pkt-input-check__input": !0,
      "pkt-input-check__input--tile": this.hasTile,
      "pkt-input-check__input--tile-disabled": this.disabled && this.hasTile
    }), a = u({
      "pkt-input-check__input-checkbox": !0,
      "pkt-input-check__input-checkbox--error": this.hasError
    }), n = u({
      "pkt-input-check__input-label": !0,
      "pkt-input-check__input-label--disabled": this.disabled,
      "pkt-input-check__input-label--left": this.labelPosition === "left",
      "pkt-input-check__input-label--right": this.labelPosition === "right",
      "pkt-sr-only": this.hideLabel
    }), l = "pkt-tag pkt-tag--small pkt-tag--thin-text", h = () => p`
        ${this.tagText ? p`<span class=${l + " pkt-tag--gray"}>${this.tagText}</span>` : r}
        ${this.optionalTag ? p`<span class=${l + " pkt-tag--blue-light"}>${this.optionalText}</span>` : r}
        ${this.requiredTag ? p`<span class=${l + " pkt-tag--beige"}>${this.requiredText}</span>` : r}
      `, c = () => p`
        <label class=${n} for=${this.id + "-internal"}>
          ${this.label} ${h()}
          ${this.checkHelptext ? p`<div class="pkt-input-check__input-helptext">${this.checkHelptext}</div>` : r}
        </label>
      `;
    return p`
      <div class="pkt-input-check">
        <div class=${t}>
          ${this.labelPosition === "left" ? c() : r}
          <input
            id=${this.id + "-internal"}
            class=${a}
            type="checkbox"
            ?disabled=${this.disabled}
            name=${this.name + "-internal"}
            ${b(this.inputRef)}
            @change=${this.handleChange}
            @click=${this.handleClick}
            @blur=${this.onBlur}
            @focus=${this.onFocus}
            ?checked=${this.checked}
            role=${this.isSwitch ? "switch" : "checkbox"}
          />
          ${this.labelPosition === "right" ? c() : r}
        </div>
      </div>
    `;
  }
  handleClick(t) {
    if (this.disabled)
      return t.preventDefault(), t.stopImmediatePropagation(), !1;
  }
  handleChange(t) {
    if (this.disabled)
      return t.preventDefault(), t.stopImmediatePropagation(), !1;
    this.toggleChecked(t);
  }
  toggleChecked(t) {
    if (this.disabled) {
      t.preventDefault(), t.stopImmediatePropagation();
      return;
    }
    const a = t.target;
    if (a && a.disabled) {
      t.preventDefault(), t.stopImmediatePropagation();
      return;
    }
    t.stopImmediatePropagation(), this.touched = !0, this.inputRef.value && (this.checked = this.inputRef.value.matches(":checked"), this.valueChecked(this.checked));
  }
};
i([
  s({ type: String, reflect: !0 })
], e.prototype, "value", 2);
i([
  s({ type: String })
], e.prototype, "checkHelptext", 2);
i([
  s({ type: Boolean })
], e.prototype, "defaultChecked", 2);
i([
  s({ type: Boolean })
], e.prototype, "hasTile", 2);
i([
  s({ type: Boolean })
], e.prototype, "isSwitch", 2);
i([
  s({ type: String })
], e.prototype, "labelPosition", 2);
i([
  s({ type: Boolean })
], e.prototype, "hideLabel", 2);
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "checked", 2);
i([
  s({ type: Boolean, reflect: !0 })
], e.prototype, "indeterminate", 2);
i([
  s({ type: String, reflect: !0 })
], e.prototype, "type", 2);
i([
  s({ type: String })
], e.prototype, "tagText", 2);
i([
  s({ type: Boolean })
], e.prototype, "optionalTag", 2);
i([
  s({ type: String })
], e.prototype, "optionalText", 2);
i([
  s({ type: Boolean })
], e.prototype, "requiredTag", 2);
i([
  s({ type: String })
], e.prototype, "requiredText", 2);
e = i([
  d("pkt-checkbox")
], e);
export {
  e as P
};
